import { TypePolicies } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';

const typePolicies: TypePolicies = {
  Owner: {
    keyFields: ["address"],
    fields: {
      questHistory: {
        merge: false,
      },
    },
  },
  OwnerQuestHistory: {
    fields: {
      questHistoryConnection: relayStylePagination(),
    },
  },
  Leaderboard: {
    fields: {
      moles: relayStylePagination(),
    },
  },
}

export default typePolicies
